import React, { useRef } from "react";
import styles from "./Files.module.scss";
import { ToggleSwitch } from "../../../ui/ToggleSwitcher/ToggleSwitcher";
import {
  setNewAssistant,
  setUpdateAssistant,
} from "../../../../../store/slices/assistantSlice";
import { useDispatch } from "react-redux";
import { Button } from "../../../ui/Button/Button";
import { GoogleDriveIcon } from "../../../../../assets/icons/GoogleDriveIcon";
import { InputFile } from "../../../ui/InputFile/InputFile";
import { errorToast } from "../../../../../utils/methods/toast";
import { TrashIcon } from "../../../../../assets/icons/TrashIcon";
import { hasJsonFile } from "../../../../../utils/methods/hasJSON";

const FileCard = ({ name, size, onDelete }) => {
  const cardRef = useRef(null);

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Байт";

    const k = 1000;
    const sizes = ["Байт", "КБ", "МБ", "ГБ", "ТБ", "ПБ", "ЭБ", "ЗБ", "ЙБ"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i)) + " " + sizes[i];
  };

  const getCurrentDate = () => {
    const now = new Date();
    return `${String(now.getDate()).padStart(2, "0")}.${String(
      now.getMonth() + 1
    ).padStart(2, "0")}.${now.getFullYear()}`;
  };

  const handleMouseEnter = () => {
    const card = cardRef.current;
    const index = Array.from(card.parentNode.children).indexOf(card);

    if ((index + 1) % 2 !== 0) {
      const prevCard = card.previousElementSibling;
      if (prevCard?.classList.contains(styles.fileCard)) {
        prevCard.style.borderBottomColor = "transparent";
      }
    }
  };

  const handleMouseLeave = () => {
    const card = cardRef.current;
    const index = Array.from(card.parentNode.children).indexOf(card);

    if ((index + 1) % 2 !== 0) {
      const prevCard = card.previousElementSibling;
      if (prevCard?.classList.contains(styles.fileCard)) {
        prevCard.style.borderBottomColor = ""; // сброс
      }
    }
  };

  return (
    <div
      className={styles.fileCard}
      ref={cardRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className={styles.fileInfo}>
        <div className={styles.fileLeft}>
          <label className={styles.fileName}>{name}</label>
          <span className={styles.fileDate}>{getCurrentDate()}</span>
        </div>
        <div className={styles.fileRight}>
          <span className={styles.fileSize}>{formatFileSize(size)}</span>
        </div>
      </div>

      <button className={styles.deleteButton} onClick={onDelete}>
        <span className={styles.icon}>
          <TrashIcon fill={"#dc2626"} />
        </span>
      </button>
    </div>
  );
};
export const Files = ({
  newAssistant,
  updateAssistant,
  onGoogleDriveClick,
}) => {
  const dispatch = useDispatch();

  const filesList = updateAssistant
    ? updateAssistant?.files
    : newAssistant?.files || [];
  const driveFile = updateAssistant
    ? updateAssistant?.driveFile
    : newAssistant?.driveFile;

  const toggleObserver = (bool) => {
    if (newAssistant) {
      const updated = {
        ...newAssistant,
        settings: { ...newAssistant.settings, useFiles: bool },
      };
      dispatch(setNewAssistant(updated));
    } else if (updateAssistant) {
      const updated = {
        ...updateAssistant,
        settings: { ...updateAssistant.settings, useFiles: bool },
      };
      dispatch(setUpdateAssistant(updated));
    }
  };

  const handleDeleteFile = (index) => {
    try {
      if (updateAssistant) {
        const updated = [...filesList];
        updated.splice(index, 1);

        if (driveFile) {
          dispatch(
            setUpdateAssistant({
              ...updateAssistant,
              driveFile: null,
            })
          );
        } else {
          dispatch(
            setUpdateAssistant({
              ...updateAssistant,
              files: updated,
            })
          );
        }
      } else {
        const updated = [...filesList];
        updated.splice(index, 1);

        if (driveFile) {
          dispatch(
            setNewAssistant({
              ...newAssistant,
              driveFile: null,
            })
          );
        } else {
          dispatch(
            setNewAssistant({
              ...newAssistant,
              files: updated,
            })
          );
        }
      }
    } catch (error) {
      errorToast("При удалении произошла ошибка");
    }
  };

  console.log(driveFile);
  
  return (
    <div className={styles.container}>
      <div className={styles.toggleContainer}>
        <div className={styles.toggleWrapper}>
          <ToggleSwitch
            bool={
              updateAssistant
                ? updateAssistant?.settings?.useFiles
                : newAssistant
                ? newAssistant?.settings?.useFiles
                : false
            }
            onToggle={toggleObserver}
          />
          <label className={styles.label}>Использовать файлы</label>
        </div>
        <small className={styles.smallText}>
          При включенной опции, Вы сможете загружать файлы собственной базы
          знаний. Ассистент будет использовать ее для обучения
        </small>
      </div>
      {(updateAssistant?.settings?.useFiles ||
        newAssistant?.settings?.useFiles) && (
        <>
          <div className={styles.fileUploadContainer}>
            {(updateAssistant?.settings?.useFiles ||
              newAssistant?.settings?.useFiles) &&
              !driveFile &&
              !hasJsonFile(filesList) && (
                <div className={styles.left}>
                  <Button
                    icon={<GoogleDriveIcon size={30} fill={"#000"} />}
                    buttonStyle={styles.googleDrive}
                    titleStyle={styles.googleDriveTitle}
                    title={"Загрузить из Google Диск"}
                    onClick={onGoogleDriveClick}
                  />
                </div>
              )}
            <div className={styles.right}>
              <InputFile
                filesList={filesList}
                // setFilesList={setFilesList}
                newAssistant={!updateAssistant ? newAssistant : null}
                updateAssistant={updateAssistant ? updateAssistant : null}
              />
            </div>
          </div>

          <div className={styles.filesWrapper}>
            {driveFile && (
              <FileCard
                name={driveFile.name}
                size={driveFile.size}
                onDelete={() => handleDeleteFile(0)}
              />
            )}
            {filesList.map((file, index) => (
              <FileCard
                key={index}
                name={file.name}
                size={file.size}
                onDelete={() => handleDeleteFile(index)}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};
